import React from 'react';
import { Text } from '@fiverr-private/typography';
import type { ComponentWithChildren } from '../types';
import { ALERT_TEXT_ID } from '../constants';

const AlertText = ({ children }: ComponentWithChildren) => <Text color="inherit">{children}</Text>;

AlertText.id = ALERT_TEXT_ID;
AlertText.displayName = 'AlertText';

export default AlertText;
